import BCComponent from "./bc_component";
import {bindActionCreators} from "redux";
import {getBonusTasks, submitBonusTask} from "game/app/actions/bonus-tasks-actions";
import connect from "react-redux/es/connect/connect";
import React from "react";

class Oblast5 extends BCComponent {

    render() {
        return (
            <div>
                <h3>Oblast 5 – PREZENTACE A SEMINÁŘE</h3>
                <div className='separate-bottom'>
                    <p>Také klasický <b>výklad - prezentace nebo přednáška</b> – stejně jako <b>interaktivní seminář</b>, nás může obohatit o nové poznatky.</p>
                    <p>Ještě více se přiučíte, když takovou <b>prezentaci vytváříte</b> - při tvorbě si totiž musíte nejen najít veškeré informace k danému tématu, ale také přemýšlet o tom, jakým způsobem téma podáte svým "žákům".</p>
                    <p>Vzdělávat se dnes můžete i <b>on-line formou tzv. webinářů</b>.</p>
                </div>

                {/* <h4>Znalostní úkoly</h4> */}

                <h4>Tvořivé úkoly</h4>
                { this.showTask('prezentace_5') }

                <h4>Otázky pro dospěláka</h4>

                { this.showTask('prezentace_4') }
                { this.showTask('prezentace_2') }

            </div>
        );
    }
}

function mapStateToProps(state,ownProps) {
    return {
        bonusTasks: state.bonusTasks,
        gameInstance: state.gameInstance
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        getBonusTasks: getBonusTasks,
        submitBonusTask: submitBonusTask
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Oblast5);
